module.exports = __webpack_public_path__ + "static/media/react.41d22b08.png";